import { Grid } from '@backend/lib-design-system';
import { Features } from '@backend/lib-feature-mgr';
import type { FC } from 'react';

import type { SearchJobOfferOutput } from '~/business/JobOffer/searchJobOffers';
import { MissionListFreeApplicationCard } from '~/components/MissionsList/FreeApplicationCard';
import { MissionListCard } from '~/components/MissionsList/MissionListCard';
import { useCheckFeatureEnabled } from '~/hooks';

interface MissionsProps {
  jobOffers: SearchJobOfferOutput[];
  onMissionClick: (jobOffer: SearchJobOfferOutput) => void;
  showDistance: boolean;
}

export const MissionList: FC<MissionsProps> = ({ jobOffers, onMissionClick, showDistance }) => {
  const freeApplicationsFeature = useCheckFeatureEnabled(Features.FreeApplications);

  return (
    <Grid.Wrapper>
      {jobOffers?.map(jobOffer => (
        <Grid.Cell key={jobOffer.refId} xs={1} s={1 / 2}>
          <MissionListCard jobOffer={jobOffer} onMissionClick={onMissionClick} showDistance={showDistance} />
        </Grid.Cell>
      ))}
      {freeApplicationsFeature && (
        <Grid.Cell xs={1} s={1 / 2}>
          <MissionListFreeApplicationCard />
        </Grid.Cell>
      )}
    </Grid.Wrapper>
  );
};
